import { RouterLink, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { importProvidersFrom } from '@angular/core';
import { SignupComponent } from './signup/signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UsersComponent } from './users/users.component';
import { authGuard } from './guards/auth.guard';
import { AnnulaDataTargetComponent } from './annula-data-target/annula-data-target.component';
import { DataAndAssementPlanComponent } from './data-and-assement-plan/data-and-assement-plan.component';

export const routes: Routes = [
    {
        path : '', 
        providers : [importProvidersFrom(CommonModule)],
        component : LoginComponent,
    },
    {
        path : 'signup', 
        providers : [importProvidersFrom(CommonModule, RouterLink)],
        component : SignupComponent
    },
    {
        path : 'dashboard', 
        providers : [importProvidersFrom(CommonModule, RouterLink)],
        component : DashboardComponent,
        canActivate : [authGuard]
    },
    {
        path : 'users', 
        providers : [importProvidersFrom(CommonModule, RouterLink)],
        component : UsersComponent,
        canActivate : [authGuard]
    },
    {
        path : 'annual-data', 
        providers : [importProvidersFrom(CommonModule, RouterLink)],
        component : AnnulaDataTargetComponent,
        canActivate : [authGuard]
    },
    {
        path : 'assessment-plan', 
        providers : [importProvidersFrom(CommonModule, RouterLink)],
        component : DataAndAssementPlanComponent,
        canActivate : [authGuard]
    },
    
];
